import { Component } from '@angular/core';

@Component({
  templateUrl: './manage-volunteers.component.html',
})
export class ManageVolunteersComponent {
  title = 'volunteers-management';
}
